import { render, staticRenderFns } from "./AddRemoveSlip.template.vue?vue&type=template&id=1f515090&scoped=true&"
var script = {}
import style0 from "./AddRemoveSlip.template.vue?vue&type=style&index=0&id=1f515090&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f515090",
  null
  
)

export default component.exports